import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import ProjectGrid from '../components/ProjectGrid';

function HeaderBlobBackground() {
  const prefersReducedMotion = useReducedMotion();

  const overlay = (
    <div
      className="absolute inset-0 bg-gradient-to-r from-[#3C083C]/60 to-[#081023]/0"
      aria-hidden
    />
  );

  if (prefersReducedMotion) {
    return (
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
        <div className="absolute inset-0 bg-gradient-to-br from-[#1d4ed8] via-[#2563EB] to-[#3b82f6]" />
        {overlay}
      </div>
    );
  }

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e40af] via-[#2563EB] to-[#3b82f6]" />

      <motion.div
        className="absolute -left-1/4 -top-1/3 h-[85%] w-[70%] rounded-full opacity-80 blur-[100px] md:blur-[40px]"
        style={{
          background: 'radial-gradient(circle, #a855f7 0%, #7c3aed 55%,rgb(62, 24, 188) 80%, transparent 100%)',
        }}
        animate={{
          x: ['-5%', '18%', '-8%', '-5%'],
          y: ['-8%', '12%', '-4%', '-8%'],
          scale: [1, 1.12, 0.94, 1],
        }}
        transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
      />

      <motion.div
        className="absolute -bottom-1/4 -right-1/4 h-[75%] w-[65%] rounded-full opacity-75 blur-[100px] md:blur-[60px]"
        style={{
          background: 'radial-gradient(circle, #9333ea 0%,rgb(58, 40, 217) 60%, #581c87 85%, transparent 100%)',
        }}
        animate={{
          x: ['8%', '-14%', '6%', '8%'],
          y: ['10%', '-6%', '14%', '10%'],
          scale: [1, 1.92, 2.1, 1],
        }}
        transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
      />

      <motion.div
        className="absolute left-1/6 top-1/4 h-[50%] w-[45%] rounded-full opacity-50 blur-[80px] md:blur-[80px]"
        style={{
          background: 'radial-gradient(circle,rgb(147, 69, 225) 0%,rgb(63, 51, 234) 45%, #6D28D9 75%, transparent 100%)',
        }}
        animate={{
          x: ['-12%', '16%', '-6%', '-12%'],
          y: ['6%', '-10%', '8%', '6%'],
          scale: [1, 1.08, 1, 0.95],
        }}
        transition={{ duration: 15, repeat: Infinity, ease: 'easeInOut' }}
      />

      {overlay}
    </div>
  );
}

function HomeTitle() {
  return (
    <motion.h1
      className="text-white md:leading-tight text-xl md:text-2xl max-w-[48rem]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.3,
        delay: 0.2,
        ease: "easeOut",
      }}
    >
      Product Designer + founder & patent holder in music tech crafting 🧙 data-driven, user-centered experiences. Currently at <a
  href="https://www.autotune.com"
  target="_blank"
  rel="noopener noreferrer"
  className="underline underline-offset-4 decoration-white/40 hover:decoration-white transition-colors"
>
  AutoTune
</a>.
    </motion.h1>
  );
}

// function HomeSubTitle() {
//   return (
//     <motion.p
//       className="font-mono-body leading-tight text-center text-zinc-300 md:text-xl"
//       initial={{ opacity: 0, y: -5 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3, delay: 0.4 }}
//     >
//       Product Designer crafting 🧙 user-centered, data-driven experiences at scale. 
//     </motion.p>
//   );
// }


const Home: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col gap-2">
      <div className="mx-auto max-w-8xl p-4 md:p-6 space-y-4 md:space-y-6">
        <motion.div
          className="relative bg-zinc-900 overflow-hidden rounded-xl p-6 md:p-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <HeaderBlobBackground />
          <div className="relative z-10 space-y-6">
            <HomeTitle />
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true, amount: 0.3 }}
              className="flex justify-start"
            >
              <a
                href="mailto:chris@christophersamuels.com?subject=Portfolio Inquiry&body=Hi Christopher,%0D%0A%0D%0AI came across your portfolio and would like to discuss..."
                className="text-base bg-white/25 text-white px-6 py-3 rounded-lg hover:bg-white/35 transition-colors"
                target="_self"
                rel="noopener noreferrer"
              >
                Let's talk
              </a>
            </motion.div>
          </div>
        </motion.div>
        <div className="work grid md:grid-cols-12 gap-4 md:gap-6">
          <ProjectGrid limit={6} />
        </div>
        {/* <div className="space-y-16 md:space-y-24 xl:space-y-32">
          <div
            className="flex items-center justify-center p-6 md:py-8 lg:py-0 mx-auto max-w-5xl">
            <figure className="text-center space-y-6 md:space-y-16">
              <div className="flex flex-col items-center space-y-8">
                <motion.div
                  data-name="QuotationIcon"
                  initial={{ opacity: 0, y: -1 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.3,
                    delay: 0.1,
                    ease: "easeOut",
                  }}
                  viewport={{ once: true, amount: 0.9 }}
                >
                  <svg className="w-24" fill="none" viewBox="0 0 140 114">
                    <path fill="currentColor" fillOpacity=".25"
                      d="M34.323 114c-6.624 0-12.043-1.357-16.259-4.071A34.224 34.224 0 0 1 7.677 99.524C4.667 94.397 2.56 89.119 1.355 83.69.452 77.96 0 73.287 0 69.668c0-14.778 3.763-28.199 11.29-40.262C18.817 17.34 30.56 7.54 46.516 0l4.065 8.143c-9.334 3.92-17.463 10.103-24.388 18.547-6.623 8.445-9.935 17.04-9.935 25.786 0 3.62.452 6.786 1.355 9.5 4.817-3.92 10.387-5.88 16.71-5.88 7.828 0 14.602 2.563 20.322 7.69 5.72 5.127 8.58 12.214 8.58 21.262 0 8.444-2.86 15.381-8.58 20.809C48.925 111.286 42.15 114 34.323 114Zm76.774 0c-6.624 0-12.043-1.357-16.258-4.071a34.225 34.225 0 0 1-10.387-10.405c-3.011-5.127-5.119-10.405-6.323-15.834-.903-5.73-1.355-10.404-1.355-14.023 0-14.778 3.764-28.199 11.29-40.262C95.591 17.34 107.333 7.54 123.29 0l4.065 8.143c-9.333 3.92-17.463 10.103-24.387 18.547-6.624 8.445-9.936 17.04-9.936 25.786 0 3.62.452 6.786 1.355 9.5 4.817-3.92 10.387-5.88 16.71-5.88 7.828 0 14.602 2.563 20.322 7.69C137.14 68.913 140 76 140 85.048c0 8.444-2.86 15.381-8.581 20.809-5.72 5.429-12.494 8.143-20.322 8.143Z" />
                  </svg>
                </motion.div>
                <motion.div
                  className="space-y-3"
                  data-name="Quote"
                  initial={{ opacity: 0, y: -1 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.3,
                    delay: 0.2,
                    ease: "easeOut",
                  }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <p className="font-serif !leading-tight text-3xl xl:text-5xl">
                    After decades of consulting experience, I can say with great confidence that Chris is an
                    exceptionally strategic talent.
                  </p>
                </motion.div>
              </div>

              <figcaption className="flex flex-col items-center space-y-1">
                <hr className="w-9 h-1 bg-neutral-300" />
                <motion.div
                  className="text-lg md:text-2xl leading-none pt-4 font-serif"
                  initial={{ opacity: 0, y: -1 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.3,
                    delay: 0.3,
                    ease: "easeOut",
                  }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  Marco Merida
                </motion.div>
                <motion.div
                  className="text-zinc-500 dark:text-zinc-400 text-base md:font-light font-mono-body"
                  initial={{ opacity: 0, y: -1 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.3,
                    delay: 0.4,
                    ease: "easeOut",
                  }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  President at Guardian Recovery Network
                </motion.div>
              </figcaption>
            </figure>
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default Home;
